import { useFormikContext } from 'formik';
import React from 'react';

import { CustomReportModalFormikValues, TIMEFRAME } from './types';
import { FREQUENCY_TYPE } from './frequency/constants';
import { CustomReportFrequency } from './frequency/Frequency';
import { CustomReportPreferedDeliveryTime } from './preferedDeliveryTime/CustomReportPreferedDeliveryTime';
import { Timeframe } from './timeframe/Timeframe';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { PillItem } from 'lib/components/SegmentedControl/types';

interface IProps {
  currentRangeValue: string;
  updateRangeValue: (rangeValue: string) => void;
}

// keep a stable display order
const TIMEFRAME_ORDER: TIMEFRAME[] = [
  TIMEFRAME.DAY,
  TIMEFRAME.WEEK,
  TIMEFRAME.MONTH,
  TIMEFRAME.YEAR,
  TIMEFRAME.CUSTOM,
];

// helper: which timeframes to exclude for a given frequency
const excludedTimeframesFor = (frequency?: string): TIMEFRAME[] => {
  if (!frequency) return [TIMEFRAME.CUSTOM];

  if (frequency.includes(FREQUENCY_TYPE.WEEKLY)) {
    return [TIMEFRAME.DAY, TIMEFRAME.CUSTOM];
  }

  if (frequency.includes(FREQUENCY_TYPE.MONTHLY)) {
    return [TIMEFRAME.DAY, TIMEFRAME.WEEK, TIMEFRAME.CUSTOM];
  }

  return [TIMEFRAME.CUSTOM];
};

const getTimeframeOptions = (frequency: string, t: TFunction): PillItem[] => {
  const excluded = excludedTimeframesFor(frequency);

  return TIMEFRAME_ORDER.filter(tf => !excluded.includes(tf)).map(tf => ({
    value: tf,
    label: t(tf),
  }));
};

export const RecurringCustomReport = ({
  currentRangeValue,
  updateRangeValue,
}: IProps) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<CustomReportModalFormikValues>();
  const timeframeOptions = getTimeframeOptions(values.recurrings.frequency, t);
  return (
    <>
      <CustomReportFrequency updateRangeValue={updateRangeValue} />
      <CustomReportPreferedDeliveryTime />
      <Timeframe
        currentRangeValue={currentRangeValue}
        updateRangeValue={updateRangeValue}
        timeframeOptions={timeframeOptions}
      />
    </>
  );
};
